import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { listWorkingHoursApi } from "../../store/features/listWorkingHours";
import "./style.css";
import { useNavigate } from "react-router-dom";

function TeamWorkingSection({ userId }) {
  const [workingData, setWorkingData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const workingHoursByID = async () => {
    const outputarray = [];
    const listWorkingHours = dispatch(
      listWorkingHoursApi({
        id: userId,
      })
    );
    listWorkingHours
      .then(async (data) => {
        if (typeof data.payload === "undefined") {
          toast.error("Some Error Occured. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (data?.payload?.status === 200) {
          if (data?.payload?.data?.length > 0) {
            data?.payload?.data?.map((item) => {
              outputarray.push({
                id: item?._id,
                day: item?.day_of_week,
                start_time: item?.start_time,
                end_time: item?.end_time,
                is_available: item?.is_available,
              });
              setWorkingData(outputarray);
            });
          } else {
            setWorkingData([]);
          }
        } else if (data?.payload?.status === 500) {
          toast.error("Some Error Occured. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (data?.payload?.status === 401) {
          toast.error("Login Expired. Please login  and try again.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/login");
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  useEffect(() => {
    workingHoursByID();
  }, []);

  const daysOfWeek = [
    { day: "Monday", id: "mon" },
    { day: "Tuesday", id: "tue" },
    { day: "Wednesday", id: "wed" },
    { day: "Thursday", id: "thu" },
    { day: "Friday", id: "fri" },
    { day: "Saturday", id: "sat" },
    { day: "Sunday", id: "sun" },
  ];

  return (
    <div className="TeamWorking-main-container">
      <p className="WorkingText">Working Hours</p>
      {daysOfWeek.map((dayObj) => {
        const item = workingData.find(
          (data) => data.day === dayObj.day && data.is_available === true
        );
        return (
          <div className="Team-Working-Main" key={dayObj.id}>
            <p className="workingtitle">{dayObj.day}</p>
            {item && item.start_time && item.end_time ? (
              <p className="workingtime">
                {item.start_time} - {item.end_time}
              </p>
            ) : (
              <p className="workingtime">Not Enabled</p>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default TeamWorkingSection;
